import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { selectedCompanyStorage } from '../storage/company/index';
import { getUnauthorizedRedirect } from './page-access.util';
import { syncStakeholderDocumentPermission } from './sync-stakeholder-document-permission';

export const useStakeholderPermissionGuard = (): null | string => {
  const location = useLocation();
  const company = selectedCompanyStorage(({ company }) => company);
  const redirect = company ? getUnauthorizedRedirect(location.pathname, company) : null;
  const unauthorizedRedirect = redirect && redirect !== location.pathname ? redirect : null;

  useLayoutEffect(() => {
    if (!unauthorizedRedirect) {
      syncStakeholderDocumentPermission(company);
    }
  }, [company, unauthorizedRedirect]);

  return unauthorizedRedirect;
};
